<template>
    <div class="sales-map-container" :class="{'animate': animate}">
        <div class="map" id='Ymap'></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-map-project',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                zoom: 13,
                offset: 150,
                ballonOffset: [100, 400],
                animate: true,
                activeBallon: null,
            }
        },
        computed: mapGetters({
            pageSetup: 'loadSalesMapPage',
            currentCity: 'loadCurrentCity',
            currentCityArr: 'loadCurrentCityArr',
            mapCoords: 'loadMapCoords',
            marMarkerPos: 'loadMapMarkersPos',
            projectItemsMap: 'loadProjectItemsMap',
            // projectItemsDefault: 'loadProjectItemsDefault',
            // projectItemsFilter: 'loadProjectItemsFilter',
        }),
        methods: {
            mapInit() {
                this.$loadScript("https://api-maps.yandex.ru/2.1.75/?apikey=5ec4cf69-f505-4a8a-8b6d-70d1e6402870&lang=ru_RU")
                .then(() => {
                    if (this.routerName == 'sales-map' && this.projectItemsMap != null && this.projectItemsMap.length > 0 && this.currentCityArr != null && this.pageSetup != null) {
                        var _self = this;
                        var location = this.currentCityArr;
                        var marker = this.pageSetup.pin_static;
                        var marker_active = this.pageSetup.pin_active;
                        var zoom = this.zoom;
                        var offset = this.offset;
                        var i;
                        var pin;
                        var Ymap;
                        var myPlacemark;
                        var links = $('.sales-filter-default a');
                        ymaps.ready().then(function() {

                            var initMap = function() {
                                Ymap = new ymaps.Map('Ymap', {
                                    center: [_self.mapCoords[0].city_map_lng, _self.mapCoords[0].city_map_lat],
                                    zoom: zoom,
                                    controls: ['fullscreenControl'],
                                    behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch"]
                                },{suppressMapOpenBlock: true, minZoom: 11, maxZoom: 18});
                                Ymap.controls.add('zoomControl', {position: {left: '10px', top: '180px'}});
                            };

                            var buildPinsOnMap = function() {
                                for (i = 0; i < _self.projectItemsMap.length; i++) {
                                    var lat = _self.projectItemsMap[i].map_lat,
                                        lng = _self.projectItemsMap[i].map_lng;

                                    myPlacemark = new ymaps.Placemark([lng,lat], {
                                        hintContent: '<div class="yandex-tooltip"><p>' + _self.projectItemsMap[i].project_name.slug.toUpperCase() + '</p></div>',
                                        balloonLayout: "default#imageWithContent",
                                        balloonContentBody: 
                                            '<div class="ballon-main-container">' +
                                                '<a class="link-to-page btn-link-more-href" href="' + 'sales/' + _self.projectItemsMap[i].project_name.slug + '" data-index="' + i + '" data-init="' + _self.projectItemsMap[i].project_site_type + '" data-name="'+ _self.projectItemsMap[i].project_name.slug +'">' +
                                                    '<div class="item-img">' +
                                                        '<img  class="baloon-pic" src="' + _self.projectItemsMap[i].project_img + '"/>' +
                                                    '</div>' + 
                                                    '<div class="item-desc">' +
                                                        '<div class="item-logo">' +
                                                            '<img src="' + _self.projectItemsMap[i].logo_color + '"/>' +
                                                        '</div>' +
                                                        '<div class="adres">' +  _self.projectItemsMap[i].project_adres  +
                                                        '</div>' +
                                                    '</div>' +
                                                '</a>' +
                                            '</div>',
                                    }, {
                                        openEmptyBalloon: false,
                                        hideIconOnBalloonOpen: false,
                                        balloonOffset: _self.ballonOffset,
                                        iconLayout: 'default#image',
                                        iconImageHref: marker,
                                        iconImageSize: [60, 75],
                                        iconImageOffset: [-20, -50]
                                    });

                                    Ymap.geoObjects.add(myPlacemark);
                                    watchEventMarkers();
                                }
                                if (_self.projectItemsMap.length == 1) {
                                    Ymap.setCenter([_self.projectItemsMap[0].map_lng, _self.projectItemsMap[0].map_lat]);
                                }
                            };

                            var watchEventMarkers = function() {
                                var hover = null;
                                myPlacemark.events
                                .add('balloonopen', function(e) {
                                    hover = 1;
                                    e.get('target').options.set('iconImageHref', marker_active);
                                    $('.btn-link-more-href').on('click', function(elem) {
                                        // console.log('click')
                                        elem.preventDefault();
                                        var dataIndex = $(this).data('index'),
                                            dataInit = $(this).data('init'),
                                            dataName = $(this).data('name');
                                        // console.log(dataIndex, dataInit, _self.projectItemsMap[dataIndex], 'attr from map');
                                        if (dataInit == 'link') {
                                            window.open(_self.projectItemsMap[dataIndex].project_site_in.link, '_blank');
                                        } else if (dataInit == 'land') {
                                            _self.$router.push({ name: 'sales-app', params: { id: _self.projectItemsMap[dataIndex].project_name.slug } })
                                        } else if (dataInit == 'promo') {
                                            _self.$router.push({ name: 'sales-app', params: { id: _self.projectItemsMap[dataIndex].project_name.slug } })
                                        } else if (dataInit == 'form') {
                                            return false;
                                        }
                                    });
                                    $('.ymaps-2-1-79-balloon-pane').addClass('animate');
                                })
                                .add('balloonclose', function(e) {
                                    hover = null;
                                    e.get('target').options.set('iconImageHref', marker);
                                    $('.ymaps-2-1-79-balloon-pane').removeClass('animate');
                                })
                                .add('mouseenter', function(e) {
                                    e.get('target').options.set('iconImageHref', marker_active);
                                })
                                .add('mouseleave', function(e) {
                                    if (hover == null) {
                                        e.get('target').options.set('iconImageHref', marker);
                                    }
                                    e.originalEvent.map.hint.close();
                                });
                            };

                            var setCenterOffset = function() {
                                var pixelCenter = Ymap.getGlobalPixelCenter('Ymap');
                                pixelCenter = [
                                    pixelCenter[0],
                                    pixelCenter[1] + offset
                                ];
                                var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                                Ymap.setCenter(geoCenter);
                            };

                            var updateSpbMap = function() { // Подгонка карты для горда Санкт-Петербург
                                _self.zoom = 11;
                                var pixelCenter = Ymap.getGlobalPixelCenter('Ymap');
                                pixelCenter = [
                                    pixelCenter[0],
                                    pixelCenter[1] - 500
                                ];
                                var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                                Ymap.setZoom(12);
                                Ymap.setCenter(geoCenter);
                            };

                            var UpdateControls = function() {
                                if ($(window).width() <= 1024) {
                                    Ymap.behaviors.disable('drag');
                                }
                            };

                            var destroyMap = function() {
                                Ymap.destroy();
                            };

                            var removeAllPins = function() {
                                Ymap.geoObjects.removeAll();
                            };

                            var updateMap = function() {
                                // _self.checkMobile();
                                destroyMap();
                                initMap();
                                buildPinsOnMap();
                                if (_self.mapCoords[0].region_lat.slug == 'nur-sultan') {
                                    setCenterOffset();
                                    // initMap();
                                } else if (_self.mapCoords[0].region_lat.slug == 'sankt-peterburg') {
                                    // console.log('azazaza', _self.zoom, _self.offset);
                                    updateSpbMap();
                                }
                                if ($(window).width() <= 767) {
                                    _self.zoom = 12;
                                    _self.offset = 50;
                                    _self.ballonOffset = [100, 240];
                                }
                            };
                            
                            var clicker = function() {
                                $('.sales-filter-city a').on('click', function() {
                                    _self.animate = false;
                                    setTimeout(() => {
                                        updateMap();
                                        setTimeout(() => {
                                            updateMap();
                                            _self.animate = true;
                                        }, 350)
                                    }, 350);
                                });
                            }

                            initMap();
                            UpdateControls();
                            buildPinsOnMap();
                            clicker();
                            updateMap();
                            
                        });
                    }
                });
            },
            checkMobile() {
                var _self = this;
                if ($(window).width() <= 767) {
                    _self.zoom = 12;
                    _self.offset = 50;
                    _self.ballonOffset = [100, 240];
                }
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.checkMobile();
            this.mapInit();
            this.$store.watch(
                (state) => state.projectItemsDefault,
                (newValue) => {
                    if (newValue) {
                        console.log('change');
                        this.mapInit();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/realestate/sales-map-objects.scss';
    @import '@/styles/respond/sales-map/respond-sales-map-objects.scss';
</style>